import React from "react";

type TextInputProps = Omit<React.InputHTMLAttributes<HTMLInputElement>, "size"> & {
    /** `lg` is the roomy phone/login size; `md` suits toolbar filters. */
    size?: "md" | "lg";
};

export const TextInput: React.FC<TextInputProps> = ({ size = "md", className = "", ...rest }) => {
    const sizeCls =
        size === "lg"
            ? "rounded-[11px] bg-[var(--surface-2)] px-3.5 py-3 text-[14px]"
            : "min-h-9 rounded-[10px] bg-[var(--surface)] px-3 text-[13px]";
    return (
        <input
            className={`w-full border border-[var(--line-2)] outline-none focus:border-[var(--accent)] ${sizeCls} ${className}`}
            {...rest}
        />
    );
};
